import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import style from './style';

/**
 * A button with color themes that takes an onClick event
 */
// testing 
export const Button = props => {
  const {
    classes,
    children,
    scheme,
    onClick,
    disabled,
    style,
    type,
    warning,
    fullWidth,
    absolute,
    fixed, // fix button to bottom left (mobile)
    fixedRight, // fix button to bottom right (mobile)
    form
  } = props;
  const className = props.className || '';

  return (
    <button
      className={`${classes.base} ${classes[scheme]} ${fullWidth ? classes.fullWidth : ''
        } ${fixed ? classes.fixed : ''} ${fixedRight ? classes.fixedRight : ''} ${absolute ? classes.absolute : ''
        } ${className} ${warning ? classes.warning : ''}`}
      disabled={disabled}
      onClick={onClick}
      style={style}
      type={type}
      form={form}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  /**
   * Available button themes ['light', 'dark']
   */
  scheme: PropTypes.string,
  /**
   * Additional style for the element
   */
  style: PropTypes.object,
  /**
   * The type of button
   */
  type: PropTypes.string,
  /**
   * Disable the input
   */
  disabled: PropTypes.bool,
  /**
   * Behavior of the button onClick
   */
  onClick: PropTypes.func,
  /**
   * Custom className
   */
  className: PropTypes.string
};

Button.defaultProps = {
  scheme: 'dark',
  disabled: false,
  style: {},
  type: 'button',
  onClick: () => { }
};

const styleAndTheme = () => style;

export default injectSheet(styleAndTheme)(Button);
